var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" "+_vm._s(_vm.username)+" "),_c('div',{ref:"local"}),_c('div',{ref:"remote"}),_c('div',_vm._l((_vm.logs),function(log,idx){return _c('p',{key:idx},[_vm._v(_vm._s(log))])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }